/**
 * 路由拦截器
 */

const fastlogin = async (to, from, next) => {
  next()
}

const interceptorsRouter = async (to, from, next) => {
  await fastlogin(to, from, next)
}

export default interceptorsRouter;
